import React from 'react';
import Axios from 'axios';
import moment from 'moment';

import AutoSuggestPlayer from '../../shared/AutoSuggest/AutoSuggestPlayer';

const ADMIN_LVL_MASTER = 0;				// same as Users.js

const autoSuggTheme = {
	container: 'react-autosuggest-std__container',
	input: 'react-autosuggest-std__input',
	inputOpen: 'react-autosuggest-std__input--open',
	inputFocused: 'react-autosuggest-std__input--focused',
	suggestionsContainer: 'react-autosuggest-std__suggestions-container',
	suggestionsContainerOpen: 'react-autosuggest-std__suggestions-container--open',
	suggestionsList: 'react-autosuggest-std__suggestions-list',
	suggestion: 'react-autosuggest-std__suggestion',
	suggestionHighlighted: 'react-autosuggest-std__suggestion--highlighted',
	//suggestionFirst: 'react-autosuggest__suggestion--first',
	//sectionContainer: 'react-autosuggest__section-container',
	//sectionContainerFirst: 'react-autosuggest__section-container--first',
	//sectionTitle: 'react-autosuggest__section-title'
};

// Constants for this dataTable
const cstTable1Headers = [
	'Date',	
	'Joueur', 
	'Saison / Année',	
	'Description',
	'Mètres',
	'',
	''
];
const cstTable2Headers = [
	'Statelo-Vies Player',	
	'Circuits', 
	'Nb Tournaments',	
	'Statelo Player',
	'Association',
];

const cstFiltOptions = ["Joueurs non-associés", "Joueurs associés", "Tous les joueurs"];

class QvneaAdmin extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
    	pageSelect: "Importation Mont-Qvnea Q-Vies",

    	sviesImportDateA: "",
    	sviesImportDateB: "",

    	manualPrograms: [],
    	manualProgramsAddEditMode: "Ajout",
			manualProg: {
				_id: "0",
				date: "",
				playerId: "0",
				playerName: "",
				year: "",
				description: "",
				meters: 20
			},

    	playerMatchups: [],
    	stateloPlayers: [],
			filtOption: cstFiltOptions[0],
			focusPlayerIdx: -1,
			selectedStateloPlayerId: "0",
			selectedStateloPlayerName: "à déterminer",
			
    };
		
		this.sviesImportDateChange = this.sviesImportDateChange.bind(this);
		this.getMontQvneaStateloViesPrograms = this.getMontQvneaStateloViesPrograms.bind(this);

		this.dispAddProgramSection = this.dispAddProgramSection.bind(this);

		this.createTable1HdrRow = this.createTable1HdrRow.bind(this);
		this.createData1Row = this.createData1Row.bind(this);
		this.createTable2HdrRow = this.createTable2HdrRow.bind(this);
		this.createData2Row = this.createData2Row.bind(this);

		this.handleAddProgramBtn = this.handleAddProgramBtn.bind(this);
		this.handleEditManualProgram = this.handleEditManualProgram.bind(this);
		this.handleDeleteManualProgram = this.handleDeleteManualProgram.bind(this);

		this.handlePageSelectChange = this.handlePageSelectChange.bind(this);
		this.handleManualProgChange = this.handleManualProgChange.bind(this);
		this.handleManualProgPlayerChange = this.handleManualProgPlayerChange.bind(this);
		this.handleAddEditManualProgram = this.handleAddEditManualProgram.bind(this);
		this.handleFiltOptionChange = this.handleFiltOptionChange.bind(this);
		this.handleSelectedStateloPlayerChange = this.handleSelectedStateloPlayerChange.bind(this);
		this.handleGoMatchIt = this.handleGoMatchIt.bind(this);
	}

  componentDidMount() {
    this.loadDataFromApi(this.state.filtOption);
  }

	loadDataFromApi(filtOption) {
    var _this = this;

    Axios.get('/api/players/').then(function(responsePlayers) {
	    Axios.get('/api/qvnea/montQvneaSviesPlayerMatchups/' + filtOption).then(function(responseMatchups) {
		    Axios.get('/api/qvnea/montQvneaManualProgram/').then(function(responseManualPrograms) {

		    	var playerMatchups = responseMatchups.data;
					playerMatchups = playerMatchups.sort((a, b) => (a.sviesPlayerName.localeCompare(b.sviesPlayerName)));

					_this.setState({
						manualPrograms: responseManualPrograms.data,
						playerMatchups: playerMatchups,
						stateloPlayers: responsePlayers.data,
						filtOption: filtOption,
						focusPlayerIdx: -1
					});

		    });
	    });
    });
  }

	render() {
		console.log('MontQvneaAdmin: render');
		// console.log(this.state.manualPrograms);
		//console.log('stateloPlayers');
		// console.log(this.state.selectedStateloPlayerId);

    return (
      <div className="row">
      <div className="col-md-12">
      	<h5>Mont-QVNEA Admin</h5>
     		{this.dispPageSelector()}
				<hr/>

				{(this.state.pageSelect === "Importation Mont-Qvnea Q-Vies") ?
     			this.dispImportQvies() : null}

				{(this.state.pageSelect === "Programmes manuels") ?
     			this.dispAddProgramSection() : null}
				{(this.state.pageSelect === "Programmes manuels") ?
	     		this.dispManualProgramsTableSection() : null}

				{(this.state.pageSelect === "Association de joueurs") ?
     			this.dispPlayerMatchupsSection(): null}

      </div>
      </div>
	  );
  }

  dispPageSelector() {
  	return(
      <div className="row">
      <div className="col-md-5">
  			<select className="form-control" type="text" id="pageSelect" value={this.state.pageSelect}
  				onChange={this.handlePageSelectChange}>
        	<option key='opt0'>Importation Mont-Qvnea Q-Vies</option>
        	<option key='opt1'>Programmes manuels</option>
        	<option key='opt2'>Association de joueurs</option>
				</select>
      </div>
      </div>
  	);
  }

	dispImportQvies() {
		return (
      <div>
      <div className="row">
      <div className="col-md-12">
      	<h5> Importation Mont-Qvnea Q-Vies </h5>

        <div className="row row-margin-bottom-10">
        <div className="col-12 col-md-4 col-lg-3">
					<span className="small"> Date début </span> <br/>
          <input className="form-control form-control-sm" type="date" id="sviesImportDateA" 
          	value={this.state.sviesImportDateA} required
            onChange={this.sviesImportDateChange}></input>
				</div>

        <div className="col-12 col-md-4 col-lg-3">
					<span className="small"> Date fin </span> <br/>
          <input className="form-control form-control-sm" type="date" id="sviesImportDateB" 
          	value={this.state.sviesImportDateB} required
            onChange={this.sviesImportDateChange}></input>
				</div>
				</div>

				<button type="button" id='gobutton' className="btn btn-primary" onClick={this.getMontQvneaStateloViesPrograms}>
					Get Statelo-Vies Programs
				</button>

      </div>
      </div>
			<hr/>

      </div>
 		);
	}

	sviesImportDateChange(e) {
		var newDate = e.target.value;
		if (e.target.id === "sviesImportDateA") {
			this.setState({	sviesImportDateA: newDate });
		} else {
			this.setState({	sviesImportDateB: newDate });			
		}
	}

  dispAddProgramSection() {
  	return(
      <div>
      <div className="row">
      <div className="col-md-12">
      	<h5> Programmes manuels </h5>

      	<p><strong>Mode: {this.state.manualProgramsAddEditMode}</strong>
      	{(this.state.manualProgramsAddEditMode === "Édition") ? 
      		<span><br/>[manual program id: {this.state.manualProg._id}]</span>
      		: null}
				</p>

				<div className="row">
				<div className="col-md-12">
					<button className={"btn btn-sm btn-player-width btn-primary"} 
						onClick={this.handleAddProgramBtn}>
						Nouveau programme
					</button>
					<br/><br/>
				</div>
				</div>

	      <div className="row">
	      <div className="col-md-3">
					<span className="small">Date du programme</span><br/>
        	<input className="form-control form-control-sm" type="date" id="date" 
        		value={this.state.manualProg.date || ""} 
          	onChange={this.handleManualProgChange}></input>
	      </div>

	      <div className="col-md-4">
					<span className="small">Joueur</span><br/>
					<AutoSuggestPlayer id="playerId" playerId={this.state.manualProg.playerId} 
						dataChange={this.handleManualProgPlayerChange}/>
	      </div>
	      </div>

	      <div className="row">
	      <div className="col-md-3">
					<span className="small">Saison / Année</span><br/>
        	<input className="form-control form-control-sm" type="string" id="year" 
        		value={this.state.manualProg.year || ""} 
          	onChange={this.handleManualProgChange}></input>
	      </div>

	      <div className="col-md-5">
					<span className="small">Description</span><br/>
        	<input className="form-control form-control-sm" type="string" id="description" 
        		value={this.state.manualProg.description || ""} 
          	onChange={this.handleManualProgChange}></input>
	      </div>

	      <div className="col-md-2">
					<span className="small">Mètres</span><br/>
        	<input className="form-control form-control-sm" type="number" id="meters" 
        		value={this.state.manualProg.meters || ""} 
          	onChange={this.handleManualProgChange}></input>
	      </div>
	      </div>

	      <div className="row">
	      <div className="col-md-5">
					<button type="button" className="btn btn-primary btn-sm btn-margin-topbottom-10" 
						onClick={this.handleAddEditManualProgram}>Sauvegarder</button>
	      </div>

	      </div>
      </div>
      </div>
				<hr/>
      </div>
  	);
  }

  handleAddProgramBtn() {
  	this.setState({
  		manualProgramsAddEditMode: "Ajout",
			manualProg: {
				_id: "0",
				date: "",
				playerId: "0",
				playerName: "",
				year: "",
				description: "",
				meters: 20
			}
  	});
  }

	handleEditManualProgram(dataRowIdx) {
		var manualProg = this.state.manualPrograms[dataRowIdx];
		manualProg.date = moment(manualProg.date).format("YYYY-MM-DD");
  	this.setState({
  		manualProgramsAddEditMode: "Édition",
			manualProg: manualProg
  	});
	}

	handleDeleteManualProgram(dataRowIdx) {
		var _this = this;
		var manualProg = this.state.manualPrograms[dataRowIdx];

		if (window.confirm("Supprimer cette entrée (" + manualProg.playerName + ")")) {

			Axios.delete('/api/qvnea/montQvneaManualProgram/' + manualProg._id)
			.then(function(response) {
				_this.loadDataFromApi(_this.state.filtOption);
			})
			.catch(function(error) {
				console.log(error);
			});
		}
	}

  dispManualProgramsTableSection() {
  	return(
      <div className="row">
      <div className="col-md-12">
  		<h5>Liste des entrées manuelles pour le Mont-QVNEA</h5>
  		<p>(Pages et tris à venir éventuellement)</p>

			<div className="table-responsive">
    	<table className="table table-striped table-hover table-sm">
				<thead>
				<tr>
					{cstTable1Headers.map(this.createTable1HdrRow)}
				</tr>
				</thead>
    		<tbody>
					{this.state.manualPrograms.map(this.createData1Row)}
      	</tbody>
      </table>
      </div>
      </div>
      </div>
  	);
  }

	createTable1HdrRow(hdrItem, hdrIdx) {
		return (
			<th key={"colid." + hdrIdx} 
				id={"colid." + hdrIdx}>
				{hdrItem}
			</th>
		);
	}

  createData1Row(dataRow, dataRowIdx) {
		return (
			<tr key={'tr.' + dataRowIdx} id={'tr.' + dataRowIdx}>
				<td>{moment(dataRow.date).format("YYYY-MM-DD")}</td>
				<td>{dataRow.playerName}</td>
				<td>{dataRow.year}</td>
				<td>{dataRow.description}</td>
				<td>{dataRow.meters}</td>
				<td><input name={'del.' + dataRow[0]} type="button" 
					onClick={this.handleEditManualProgram.bind(this, dataRowIdx)} 
					value="Editer"/></td>
				<td><input name={'del.' + dataRow[0]} type="button" 
					onClick={this.handleDeleteManualProgram.bind(this, dataRowIdx)} 
					value="Supprimer"/></td>
      </tr>
    );
  }

  dispPlayerMatchupsSection() {
		var partAlastItemIdx = this.state.playerMatchups.length;
		if (this.state.focusPlayerIdx !== -1) {
			partAlastItemIdx = this.state.focusPlayerIdx + 1;
		}

  	return(
      <div className="row">
      <div className="col-md-12">

      <h5>Association de joueurs</h5>

      <div className="row">
      <div className="col-md-4">
      	<span>Options d'affichage</span>
  			<select className="form-control form-control-sm input-sm" type="text" id="filtOption" value={this.state.filtOption}
  				onChange={this.handleFiltOptionChange}>
        	<option key='opt0'>{cstFiltOptions[0]}</option>
        	<option key='opt1'>{cstFiltOptions[1]}</option>
        	<option key='opt2'>{cstFiltOptions[2]}</option>
				</select>
      </div>
      </div>
      <br/>

			<div className="table-responsive">
    	<table className="table table-striped table-hover table-sm">

				<thead>
				<tr>
					{cstTable2Headers.map(this.createTable2HdrRow)}
				</tr>
				</thead>

				{(this.state.playerMatchups.length === 0) ?
    			<tbody><tr><td colSpan="99">Aucun résultat</td></tr></tbody> :						
    			<tbody>{this.state.playerMatchups.slice(0, partAlastItemIdx).map(this.createData2Row.bind(this, 0))}</tbody>}

    		{(this.state.focusPlayerIdx !== -1) ?
					<tbody>{this.matchPlayerSection()}</tbody>
					: null}

      	{(this.state.focusPlayerIdx !== -1) ?
      		<tbody>
						{this.state.playerMatchups.slice(partAlastItemIdx, this.state.playerMatchups.length).map(this.createData2Row.bind(this, partAlastItemIdx))}
		  		</tbody>
      		: null}

      </table>
      </div>

    	</div>
   	 </div>
  	);
  }

	createTable2HdrRow(hdrItem, hdrIdx) {
		return (
			<th key={"colid." + hdrIdx} 
				id={"colid." + hdrIdx}>
				{hdrItem}
			</th>
		);
	}

  createData2Row(idxOffset, dataRow, dataRowIdx) {
  	var tableRowIdx = idxOffset + dataRowIdx;
    var circuitNamesCell = dataRow.circuitNames.map(function(line, lineIdx) {
			return (<span key={"line."+lineIdx}>{line}<br/></span>);
		});

    // matched player ?
    var wasMatched = (dataRow.stateloPlayerId !== "0");
		var stateloPlayerIdTxt = "";
		var stateloPlayerNameTxt = dataRow.stateloPlayerName;
		var matchButtonTxt = "Associer le joueur";
		if (!wasMatched) {
			stateloPlayerNameTxt = "non-associé";
		} else {
			stateloPlayerIdTxt = "[" + dataRow.stateloPlayerId + "]";
			matchButtonTxt = "Dissocier"
		}

		return (
			<tr key={'tr.' + tableRowIdx} id={'tr.' + tableRowIdx}>
				<td>{dataRow.sviesPlayerName}<br/>[{dataRow.sviesPlayerId}]</td>
				<td>{circuitNamesCell}</td>
				<td>{dataRow.nbTournaments}</td>
				<td>{stateloPlayerNameTxt}<br/>{stateloPlayerIdTxt}</td>
				<td><input name={'del.' + dataRow[0]} type="button" 
					onClick={this.handleMatchPlayer.bind(this, wasMatched, tableRowIdx)} 
					value={matchButtonTxt}/></td>
      </tr>
    );
  }

	matchPlayerSection() {
		var playerSelected = this.state.playerMatchups[this.state.focusPlayerIdx];
		var buttonDisable = (this.state.selectedStateloPlayerId === "0");

		return (
				<tr className="nohovernostripes-row">
				<td colSpan="99">

		      <div className="row">
		      <div className="col-md-12">
						<br/>
						<p><strong>Association de joueurs</strong></p>
		      </div>
		      </div>

		      <div className="row">
		      <div className="col-md-3">
						<strong>Joueur Statelo-Vies</strong><br/>
						{playerSelected.sviesPlayerName}<br/><br/>
		      </div>
		      </div>

		      <div className="row">
		      <div className="col-md-3">
						<strong>Joueur Statelo</strong><br/>
						{this.state.selectedStateloPlayerName}<br/><br/>
		      </div>
			    <div className="col-md-3">
						<strong>Recherche du joueur Statelo</strong>
						<AutoSuggestPlayer playerId={this.state.selectedStateloPlayerId} 
							dataChange={this.handleSelectedStateloPlayerChange}/>
		      </div>
		      </div>

		      <div className="row">
		      <div className="col-md-3">
		      </div>
		      <div className="col-md-3">
						<button className="btn btn-sm btn-primary btn-margin-right-20" onClick={this.handleGoMatchIt} disabled={buttonDisable}>
							Associer
						</button>
		      </div>
		      </div>

		      <br/>
		      <br/>

				</td>
				</tr>
		)	
	}

	handlePageSelectChange(e) {
		this.setState({
			pageSelect: e.target.value,

			// reset these
			focusPlayerIdx: -1,
			selectedStateloPlayerId: "0",
			selectedStateloPlayerName: "à déterminer"
		});
	}

	handleManualProgChange(e) {
		var manualProg = this.state.manualProg;
		manualProg[e.target.id] = e.target.value;
    this.setState({manualProg: manualProg});
	}

	handleManualProgPlayerChange (playerId, playerName) {
		var manualProg = this.state.manualProg;
		manualProg.playerId = playerId;
		manualProg.playerName = playerName;
		this.setState({
			manualProg: manualProg
		})
	}

	handleAddEditManualProgram() {
		var _this = this;
		var manualProg = this.state.manualProg;

		// validation
		var valideData = true;
		if (manualProg.date === "") {
			valideData = false;
		}
		if (manualProg.playerId === "0") {
			valideData = false;
		}
		if (manualProg.year === "") {
			valideData = false;
		}
		if (manualProg.description === "") {
			valideData = false;
		}

		if (!valideData) {
			alert('Tous les champs doivent être remplis');
			return;
		}

		// create post object
		var programObj = {
			_id: manualProg._id,
			date: manualProg.date,
			playerId: manualProg.playerId,
			year: parseInt(manualProg.year, 10),
			description: manualProg.description,
			meters: parseInt(manualProg.meters, 10),
			system: "Manual Entry",
		};

		// post to montQvneaSviesPlayerMatchups
		Axios.post('/api/qvnea/montQvneaManualProgram', {
			programId: programObj._id,
			programObj: programObj,
		})
		.then(function(response) {
			//console.log('save success');
			_this.loadDataFromApi(_this.state.filtOption);
			alert('Entrées ajoutée');
		})
		.catch(function(error) {
			console.log(error);
		});		

	}

	handleFiltOptionChange(e) {
		this.loadDataFromApi(e.target.value)
	}

	handleMatchPlayer(wasMatched, tableRowIdx) {
		var _this = this;
		// if player was matched, unmatch it on click (with confirmation)
		if (wasMatched) {

			var matchedPlayerStr = this.state.playerMatchups[tableRowIdx].sviesPlayerName + ' / ' + 
				this.state.playerMatchups[tableRowIdx].stateloPlayerName;

			if (window.confirm('dissocier ce joueur ? [' + matchedPlayerStr + ']')) {

				Axios.delete('/api/qvnea/montQvneaSviesPlayerMatchups/' + this.state.playerMatchups[tableRowIdx].sviesPlayerId)
				.then(function(response) {
				
					// Reload data					
					_this.loadDataFromApi(_this.state.filtOption);
				})
				.catch(function(error) {
					console.log(error);
				});

			}
		// was not matched, show match section
		} else {

			if (this.state.focusPlayerIdx !== tableRowIdx) {
				this.setState({
					focusPlayerIdx: tableRowIdx,
					selectedStateloPlayerId: "0",
					selectedStateloPlayerName: "à déterminer"
				});
			} else {
				this.setState({
					focusPlayerIdx: -1,
					selectedStateloPlayerId: "0",
					selectedStateloPlayerName: "à déterminer"
				});
			}
		}
	}

	handleSelectedStateloPlayerChange(playerId, playerName) {
		console.log('selected player CHANGE');
		this.setState({
			selectedStateloPlayerId: playerId,
			selectedStateloPlayerName: playerName
		});
	}

	handleGoMatchIt(e) {
		var _this = this;
		var playerSelected = this.state.playerMatchups[this.state.focusPlayerIdx];

		console.log('MATCH IT !');
		console.log(playerSelected.sviesPlayerId);
		console.log(this.state.selectedStateloPlayerId);

		// validate playerId 
		if (this.state.selectedStateloPlayerId !== "0") {

			// post to montQvneaSviesPlayerMatchups
			Axios.post('/api/qvnea/montQvneaSviesPlayerMatchups', {
				sviesPlayerId: playerSelected.sviesPlayerId,
				stateloPlayerId: this.state.selectedStateloPlayerId
			})
			.then(function(response) {
				//console.log('save success');
				// Reload data					
				_this.loadDataFromApi(_this.state.filtOption);
			})
			.catch(function(error) {
				console.log(error);
			});		
		}
	}

	getMontQvneaStateloViesPrograms(e) {
		var _this = this;
		Axios.post('/api/qvnea/importStateloViesPrograms', {
			dateA: _this.state.sviesImportDateA,
			dateB: _this.state.sviesImportDateB
		})
		.then(function(response) {
			console.log('SCRIPT DONE: ');
		})
		.catch(function(error) {
			console.log(error);
		});;
	}
	
}

export default QvneaAdmin;

